export default (JSONData, ReportTitle, ShowLabel) => {
  let arrTemp = typeof JSONData != 'object' ? JSON.parse(JSONData) : JSONData
  let arrData = []
  let counter = 1
  let timestamp = new Date().getTime()
  arrTemp.forEach(element => {
    let line = ['Grupo ' + counter++]
    arrData.push(line)
    element.players.forEach(player => {
      let row = [
        player.country,
        player.name + ', ' + player.surname,
        player.score
      ]
      arrData.push(row)
    })
  })
  let CSV = ''
  CSV += ReportTitle + '\r\n\n'
  if (ShowLabel) {
    let row = ''
    for (let index in arrData[0]) {
      row += index + ';'
    }
    row = row.slice(0, -1)
    CSV += row + '\r\n'
  }
  for (let i = 0; i < arrData.length; i++) {
    let row = ''
    for (let index in arrData[i]) {
      row += '"' + arrData[i][index] + '";'
    }
    row.slice(0, row.length - 1)
    CSV += row + '\r\n'
  }

  if (CSV == '') {
    alert('Invalid data')
    return
  }
  let fileName = 'Onlygames_'
  fileName += ReportTitle.replace(/ /g, '_')
  fileName += timestamp
  let uri = 'data:text/csv;charset=utf-8,' + escape(CSV)
  let link = document.createElement('a')
  link.href = uri
  link.style = 'visibility:hidden'
  link.download = fileName + '.csv'
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}



/** WEBPACK FOOTER **
 ** ./src/utils/jsontocsv.js
 **/